const SearchFieldStyles = {
    container: () => ({
        width: '100%',
    }), 
    control: (styles, { isDisabled, readOnly }) => ({
        ...styles,
        marginTop: '15px',
        color: isDisabled || readOnly ? '#B8B8B8' : '#707070',
        border: isDisabled || readOnly ? '1px solid #5f5f5f' : '',
        backgroundColor: isDisabled || readOnly ? '#565656' : '#343434',
        borderRadius: "10px",
        padding: "3px"
    }),
    option: (styles, { isDisabled }) => {
        return {
            ...styles,
            backgroundColor: '#343434',
            color: '#707070',
            border: 'none',
            whiteSpace: 'pre-wrap'
        }
    },
    input: (styles) => ({ ...styles, color: "#707070" }),
    singleValue: (styles, { isDisabled, readOnly }) => ({ ...styles, whiteSpace: 'pre-wrap', color: (isDisabled || readOnly ? "#B8B8B8" : "#707070") }),
    multiValue: (styles) => ({ 
        ...styles, 
        color: "whitesmoke", 
        backgroundColor: "#343434", 
        border: "1px solid whitesmoke", 
        borderRadius: "6px" 
    }),
    multiValueLabel: (styles) => ({ ...styles, color: "whitesmoke" }),
    menuList: (styles) => ({ ...styles, backgroundColor: "#343434"}),
}

export { SearchFieldStyles };